/// <reference path="giftCardIntegration.module.ts" />
/// <reference path="../../components/common/businessinfo.service.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.GiftCardIntegration {
  class GiftCardIntegrationController extends Meevo.Components.CommonClasses.CommonControllerBase {
    // statically inject constructor resources
    static $inject = [
      "meevo.AppSettings",
      "meevo.components.common.BusinessInfoDataService",
      "meevo.components.modal.ModalService",
      "meevo.components.common.IdentityService",
      "meevo.components.logging.LoggingService",
      "meevo.components.common.SecurityService",
      "$rootScope",
      "$scope",
      "$state",
      "meevo.ContextParams",
      'meevo.components.short-cuts.ShortCutsService',

      "meevo.components.busy.BusyService",
      "$translate"];

    constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
      protected dataService: Meevo.Components.Common.BusinessInfoDataService,
      protected modalService: Meevo.Components.Modal.IModalService,
      protected identityService: Meevo.Components.Common.IIdentityService,
      protected loggingService: Meevo.Components.Logging.ILoggingService,
      protected securityService: Meevo.Components.Common.ISecurityService,
      protected $rootScope: angular.IRootScopeService,
      protected $scope: angular.IScope,
      protected $state: any,
      protected contextParams: Meevo.IContextParams,
      protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,

      protected busyService: Meevo.Components.Busy.IBusyService,
      protected $translate: angular.translate.ITranslateService) {

      super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

      this.createContext();
    }

    createContext(): void {
      let vm = this;
      vm.busyService.start();
      vm.securityService.checkSection(vm.meevoSecurityKeys.DATA_GIFTCARDINTEGRATION).then(() => {
        vm.busyService.stop();
        vm.context = new GiftCardIntegrationContext(vm.appSettings, vm.dataService, vm.modalService, vm.identityService, vm.loggingService, this.securityService, vm.$translate);
        super.createContext();

        vm.context.postUpdate = (model: any) => {
          if (Model.Guard.isSomething(this.context.closeCallback))
            this.context.closeCallback(model, true);
        }
      });
    }
  }

  angular.module("meevo.plugins.giftCardIntegration")
    .controller("meevo.plugins.giftCardIntegration.GiftCardIntegrationController", GiftCardIntegrationController);
}